import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";
import moment from "moment";

import {
  GetAllPembayaranVA,
  reset,
} from "../../../features/pembayaran_va/PembayaranVASlice";

import {
  Card,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Form,
} from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  faSearch,
  faPlus,
  faEye,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { hideLoadingDialog, showAlertDialog, showFailedDialog, showLoadingDialog, showSuccessDialog } from '../../../helpers/dialog.helper';
import axios from 'axios';
import BASE_URL from "../../../api";
import PaginationComponent from "../../../components/admin/PaginationComponent";
import { UserContext } from "../../../utils/ProtectedRoute";
import { formatNumber } from "../../../helpers/helper";

const ListPembayaranVAPage = () => {
  const sortByList = [
    {
      id: "created_at",
      name: "Tanggal Dibuat",
    },
    {
      id: "va_name",
      name: "Nama VA",
    },
  ];

  const sortTypeList = [
    {
      id: "ASC",
      name: "Paling Awal",
    },
    {
      id: "DESC",
      name: "Paling Akhir",
    },
  ];

  const { userData } = useContext(UserContext);

  const [query, setQuery] = useState("");
  const [sortBy, setSortBy] = useState("created_at");
  const [sortType, setSortType] = useState("DESC");
  const [row, setRow] = useState("10");
  const [page, setPage] = useState("1");

  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.pembayaranVA);

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchDataListPembayaranVA();
  }, [dispatch, token, page, query, sortBy, sortType, row]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchDataListPembayaranVA();
  };

  const fetchDataListPembayaranVA = () => {
    dispatch(reset());
    dispatch(
      GetAllPembayaranVA({
        token: `${token}`,
        query: `?pageNumber=${page}&q=${query}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}`,
      })
    );
  }

  const handlePagination = (item) => {
    setPage(item);
  };

  const onClickDelete = (id) => {
    showAlertDialog({
      title: "Hapus?",
      msg: "Apakah anda yakin ingin menghapus ini?",
      confirmButtonText: "Hapus",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.delete(
              `${BASE_URL}va/${id}`,
              {
                headers: {
                  Authorization: token,
                },
              }
            );
            console.log("RESPONSE : ", response);
            hideLoadingDialog();
            showSuccessDialog({
              title: "Berhasil!",
              msg: "Berhasil menghapus data!"
            });
            fetchDataListPembayaranVA();
          } else {
            throw "id not found!"
          }
        } catch (error) {
          console.log("ERROR", error)
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menghapus data!"
          });
        }
      },
    })
  }

  return (
    <AdminLayout>
      <Header title="Pembayaran VA">
        <Button
          as={Link}
          variant="outline-primary"
          size="sm"
          to={`/${pathname.split("/")[1]}/create`}
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Tambah
        </Button>
      </Header>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between">
              <form onSubmit={handleSearch}>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </InputGroup>
              </form>
              <div className="d-flex gap-3">
                <Form.Group>
                  <Form.Select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    {sortByList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Select
                    value={sortType}
                    onChange={(e) => setSortType(e.target.value)}
                  >
                    {sortTypeList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Table
            responsive
            striped
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-0">#</th>
                {
                  userData?.id_role !== "HA05" ? 
                  <th>Nama</th> : null
                }
                <th className="border-0">VA</th>
                <th className="border-0">Kategori</th>
                <th className="border-0">Nominal</th>
                <th className="border-0">Status</th>
                <th className="border-0">Tanggal Dibuat</th>
                <th className="border-0">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <th colSpan="7" style={{textAlign:"center"}}>Loading</th>
                </tr>
              ) : (data?.items || []).length > 0 ? (
                data?.items?.map((item, i) => (
                  <tr key={item.id}>
                    <th>{((page-1)*10) + (i + 1)}</th>
                    {
                      userData?.id_role !== "HA05" ? 
                      <th>{item.va_name}</th> : null
                    }
                    <th>{item.va}</th>
                    <th>{item.payment_category}</th>
                    <th>{formatNumber(item.nominal) || "0"}</th>
                    <th>{item.paid ? "LUNAS" : "BELUM LUNAS"}</th>
                    <th>
                      {moment(item.created_at).format("DD MMM YYYY HH:mm:ss")}
                    </th>
                    <th>
                      <ButtonGroup size="sm">
                        <Button as={Link} to={`/va/detail/${item.id}`}>
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                        {item.paid ? null : (
                          <>
                            {
                              userData?.id_role !== "HA05" ? null : (
                                <Button
                                  as={Link}
                                  variant="warning"
                                  to={`/va/edit/${item.id}`}
                                >
                                  <FontAwesomeIcon icon={faEdit} />
                                </Button>
                              )
                            }
                            <Button 
                              variant="danger"
                              onClick={() => onClickDelete(item.id)}>
                              <FontAwesomeIcon icon={faTrash} />
                            </Button>
                          </>
                        )}
                      </ButtonGroup>
                    </th>
                  </tr>
                ))
              ) : (
                <tr>
                  <th colSpan="7" style={{textAlign:"center"}}>Tidak ada data!</th>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <Form.Group>
                <Form.Select
                  placeholder="Row"
                  value={row}
                  onChange={(e) => setRow(e.target.value)}
                >
                  <option defaultValue="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </Form.Select>
              </Form.Group>

              <PaginationComponent
                meta={data?.meta}
                handlePagination={(item) => handlePagination(item)}
              />
            </div>
          </div>
        </Card.Footer>
      </Card>
    </AdminLayout>
  );
};

// const PaginationItem = ({ totalPage, currentPage, handlePagination }) => {
//   const pageNumber = Array.from({ length: totalPage }, (_, index) => index + 1);
//   return (
//     <>
//       {pageNumber.map((item) => (
//         <Pagination.Item
//           key={item}
//           disabled={item === currentPage ? true : false}
//           onClick={() => handlePagination(item)}
//         >
//           {item}
//         </Pagination.Item>
//       ))}
//     </>
//   );
// };

export default ListPembayaranVAPage;
